<div class="container-fluid">
    <div class="alert alert-danger alertMessageStyles80" role="alert" *ngIf="displayLoginFailure">
        <h5 class="H5Normal" style="display:inline">{{this.failureText}}</h5>
        <h5 class="H5Normal" style="display:inline;float:right;" (click)="HideLoginFailure()">X</h5>
    </div>
    <div class="alert alert-success alertMessageStyles80" role="alert" *ngIf="displaySuccessAlert">
        <h5 class="H5Normal" style="display:inline">{{this.successText}}</h5>
        <h5 class="H5Normal" style="display:inline;float:right;" (click)="HideSuccessAlert()">X</h5>
    </div>

    <div class="container-fluid text-center whiteBackground" (mouseenter)="this.dotComService.DisplaySubMenu('')">
        <div class="row pt-5">
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            <H3 class="col-lg-4 DIN2014Regular blackText" style="text-align: left;font-size: 28pt;">PASSWORD RESET</H3>
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
        </div>

        <div class="row">
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            <h5 class="col-lg-4" style="display:inline"><input type="password" Class="DIN2014Regular"
                    [(ngModel)]="password" style="width:100%;padding-left:10pt;font-size:18pt;line-height: 3;"
                    placeholder="NEW PASSWORD">
            </h5>
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
        </div>
        <div class="row">
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            <h5 class="col-lg-4" style="display:inline"><input type="password" Class="DIN2014Regular"
                    [(ngModel)]="passwordConfirm" style="width:100%;padding-left:10pt;font-size:18pt;line-height: 3;"
                    placeholder="CONFIRM NEW PASSWORD">
            </h5>
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
        </div>

        <div class="row pt-5 pb-5">
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
            <h3 class="col-lg-2 DIN2014Regular whiteText" style="text-align: left;"><a
                    class="DIN2014Bold blueBackground whiteText"
                    style="font-size:20pt;padding:8pt; text-decoration: none !important"
                    (click)="SubmitClicked()">SUBMIT</a>
                <a class="DIN2014Bold blueBackground whiteText"
                    style="margin-left:20px; font-size:20pt;padding:8pt; text-decoration: none !important"
                    (click)="CancelResetClicked()">CANCEL</a>
            </h3>
            <div class="d-xs d-lg-block col-lg-4 text-center" style="padding-top:3%"></div>
        </div>
    </div>
</div>